import { Pagination, Select, Table } from 'antd';
import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

const { Option } = Select;

export const TableCustomV2 = ({ isLoading, columns, dataSource, totalItem, params, setParams, ...props }) => {
  return (
    <Table
      {...props}
      loading={isLoading}
      columns={columns}
      dataSource={dataSource}
      pagination={false}
      scroll={{
        x: 'max-content',
      }}
      footer={() =>
        dataSource?.length > 0 ? (
          <div className="flex flex-row justify-between">
            <Pagination
              pageSize={params?.limit}
              current={params?.page}
              total={totalItem}
              onChange={(page) => setParams({ ...params, page: page })}
              showSizeChanger={false}
              itemRender={(current, type, originalElement) => {
                if (type === 'prev') {
                  return <CaretLeftOutlined />;
                }
                if (type === 'next') {
                  return <CaretRightOutlined />;
                }
                return originalElement;
              }}
            />
            <div className="flex flex-row justify-end items-center gap-2">
              <Select value={params?.limit} onChange={(value) => setParams({ ...params, page: 1, limit: value })}>
                <Option value={10}>10</Option>
                <Option value={20}>20</Option>
                <Option value={50}>50</Option>
              </Select>
              <div className="text-sm text-[#667085] whitespace-nowrap">
                Hiển thị từ {(params?.page - 1) * params?.limit + 1}-{Math.min(params?.page * params?.limit, totalItem)}{' '}
                của {totalItem}
              </div>
            </div>
          </div>
        ) : null
      }
      bordered
    />
  );
};

TableCustomV2.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  columns: PropTypes.object.isRequired,
  dataSource: PropTypes.array.isRequired,
  totalItem: PropTypes.number.isRequired,
  params: PropTypes.object.isRequired,
  setParams: PropTypes.func.isRequired,
};
